import { render, staticRenderFns } from "./LazyImage.vue?vue&type=template&id=09372ee6&scoped=true"
import script from "./LazyImage.js?vue&type=script&lang=js&external"
export * from "./LazyImage.js?vue&type=script&lang=js&external"
import style0 from "./LazyImage.scss?vue&type=style&index=0&id=09372ee6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09372ee6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SecondaryLoadingSpinner: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/common/SecondaryLoadingSpinner.vue').default})
